const SELECTOR = '.checkout-items';
const START_TIME = '.start-time';
const END_TIME = 'span.end-time-hint';
const SERVICE_QUANTITY = '.service-quantity';
const DEFAULT_END_DATE = '--:--';

class UpdateEndTime {
  constructor() {
    if ($(SELECTOR)) {
      this.attachEventHandlers();
    }
  }

  attachEventHandlers() {
    var this_class = this;
    this_class.action(SERVICE_QUANTITY);
    $(SERVICE_QUANTITY).on('input', function(e) {
      this_class.action(this);
    });
    $(START_TIME).on('dp.change', function(e) {
      this_class.action(this);
    });

    $(SELECTOR).on('cocoon:after-insert', (event, addedElement) => {
      $(addedElement)
        .find('.form-group .end-time-hint')
        .each((i, element) => {
          $(element)
            .closest('.form-group')
            .find(SERVICE_QUANTITY)
            .on('input', function(e) {
              this_class.action(element);
            });
          $(element)
            .closest('.form-group')
            .find(START_TIME)
            .on('dp.change', function(e) {
              this_class.action(element);
            });
        });
    });
  }

  action(ele) {
    let context = $(ele)
      .closest('.form-group')
      .parent('div')
      .find(END_TIME);
    var quantity = $(ele)
      .closest('.form-group')
      .parent('div')
      .find(SERVICE_QUANTITY)
      .val();
    var startTime =
      '2011-01-01 ' +
      $(ele)
        .closest('.form-group')
        .parent('div')
        .find(START_TIME)
        .val();
    var endTime = DEFAULT_END_DATE;
    if (quantity) {
      var date = new Date(startTime);
      var hours = parseFloat(quantity);
      var d = new Date(date.getTime() + hours * 60000 * 60);
      endTime = d.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      });
    }
    context.html(endTime);
  }
}

export default UpdateEndTime;



// WEBPACK FOOTER //
// ./src/javascripts/UpdateEndTime.js